var React = require('react');

function Heading2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22,18 L15.174,18 C15.588,16.785 16.778,15.943 18.53,14.848 C20.625,13.538 23,12.054 23,9 C23,6.243 20.757,4 18,4 C15.243,4 13,6.243 13,9 C13,9.552 13.447,10 14,10 C14.553,10 15,9.552 15,9 C15,7.346 16.346,6 18,6 C19.654,6 21,7.346 21,9 C21,10.815 19.666,11.779 17.47,13.152 C15.375,14.462 13,15.945 13,19 C13,19.553 13.447,20 14,20 L22,20 C22.553,20 23,19.553 23,19 C23,18.447 22.553,18 22,18 M11,5 L11,19 C11,19.553 10.553,20 10,20 C9.447,20 9,19.553 9,19 L9,13 L3,13 L3,19 C3,19.553 2.553,20 2,20 C1.447,20 1,19.553 1,19 L1,5 C1,4.448 1.447,4 2,4 C2.553,4 3,4.448 3,5 L3,11 L9,11 L9,5 C9,4.448 9.447,4 10,4 C10.553,4 11,4.448 11,5","id":"path-1"}));
}

Heading2.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor","stroke":"none"};

module.exports = Heading2;

Heading2.default = Heading2;
